import backendURLs from '~/misc/backendURLs';

export default (axios, sessionId, params) => {
  return axios
    .get(`${backendURLs.stripe}/order-by-checkout-session/${sessionId}`, {
      params
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
